export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            了解更多关于91影视看片下载
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            国内领先的免费影视大全追剧平台
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              91影视看片下载致力于为广大影视爱好者提供免费、高清、流畅的在线观影体验。作为国内领先的免费影视大全追剧平台，我们每日更新海量电影、电视剧、综艺、动漫等影视资源，覆盖动作、喜剧、科幻、悬疑、爱情等全类型内容。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              平台与天美麻花星空影视等优质内容方深度合作，天美麻花星空影视免费观看专区每日同步更新，麻花星空影视免费观看用户可在本站直接访问独家内容，确保资源丰富、更新及时。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
              我们始终坚持用户至上的理念，不断优化播放体验。高清免费影视无需注册会员，无需任何费用，打开浏览器即点即看。多线路智能切换确保全国用户均可流畅播放，让每一位访问者都能享受极致的免费追剧体验。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-background-200/70">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">3年+</div>
                <div className="text-foreground-500 text-xs mt-1">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">20万+</div>
                <div className="text-foreground-500 text-xs mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">每日更新</div>
                <div className="text-foreground-500 text-xs mt-1">内容同步</div>
              </div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">全免费</div>
                <div className="text-foreground-500 text-xs mt-1">无需会员</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}